// extracted by mini-css-extract-plugin
export default {"image-wrap":"iconLogo_image-wrap__5Po5+"};